import { useEffect,useState } from "react";
import { useParams } from "react-router-dom";
import {connect} from "react-redux";
import { setRoomsSecondUserIdArray } from "../../redux/actions/actions.js";
import { useNavigate } from "react-router-dom";
import Messages_Room from "./Messages_Room";

const Messages_Rooms = (props) => {
    const [rooms,setRooms] = useState([]);
    const params = useParams();
    const navigate = useNavigate();
    let array = [];

    const getRooms = (id) => {
        fetch(`/rooms?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setRooms(data);
        })
        .catch(error => console.log(error));
    }
    useEffect(() => {
        const updateRooms = setInterval(() => {
            getRooms(params.id);
        }, 3000);
        return () => clearInterval(updateRooms);
    },[]);
    useEffect(() => {
        rooms.forEach(elem => {
            return(
                elem.user_one_id == params.id ? array.push({following_id:elem.user_two_id}) : array.push({following_id:elem.user_one_id})
            )
        });
    })
    const handleClick = () => {
        navigate(`/messages/${params.id}/search`);
        props.onSetRoomsSecondUserIdArray(array);
    }
    return(
        <>
            <div onClick={handleClick} className={`messages_rooms_create_new background_change_hover background_change_hover_${props.color_background} customize_text_color_${props.color_button} main_content_section_${props.color_background}`}>Start a new chat</div>
            {
                rooms.map(room => {
                    return(
                        <Messages_Room key={room.id} room_id={room.id} user_one={room.user_one_id} user_two={room.user_two_id} />
                    )
                })
            }
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        color_button: state.getColorButton.color_button,
        rooms_second_user_id_array: state.setRoomsSecondUserIdArray.rooms_second_user_id_array
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onSetRoomsSecondUserIdArray: (arr) => dispatch(setRoomsSecondUserIdArray(arr))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Messages_Rooms);